import { useEffect, useState } from 'react';

import { useLocation } from 'react-router-dom';

import { LocalStorageKeys } from '@pkg/types';

export const useAuthEntryPoint = () => {
    const { pathname } = useLocation();
    const [authEntryPointLoaded, setAuthEntryPointLoaded] = useState(false);

    /**
     * If user navigates away from the the authentication entry point,
     * remove this information from local storage.
     */
    useEffect(() => {
        const authEntryPoint = localStorage.getItem(LocalStorageKeys.AuthEntryPoint);
        if (!authEntryPointLoaded && pathname === authEntryPoint) {
            setAuthEntryPointLoaded(true);
        }

        if (authEntryPointLoaded && location.pathname !== authEntryPoint) {
            localStorage.removeItem(LocalStorageKeys.AuthEntryPoint);
        }
    }, [authEntryPointLoaded, pathname]);
};
